<div
  class="section-deliverable-droplist w-full"
  [ngClass]="{ 'drag-target': scopeElementsService.deliverableDragging }"
  id="list-{{ section.id }}"
  [cdkDropListConnectedTo]="tableConfig?.sectionDrops"
  cdkDropList
  [cdkDropListData]="section.deliverables"
  [cdkDropListDisabled]="!scopeApprovalFlowService.isScopeEditable(tableConfig?.scopeVersion)"
  (cdkDropListDropped)="onDropDeliverable.emit({ event: $event, section })">
  <div class="w-full h-fit">
    <div class="flex-col w-full">
      <div
        class="flex flex-row w-full items-center h-10 py-2"
        (click)="toggleSection()">
        <div
          class="column level-1"
          [ngClass]="tableConfig?.mainColumnClass">
          <div class="flex items-center">
            <mat-icon
              class="arrow orange material-symbols-rounded"
              [ngClass]="{
                active:
                  scopeTabService.sectionSelectedStates[section.id] || section.id == scopeElementsService.dragTargetId,
              }"
              >expand_more</mat-icon
            >
            <i class="item-icon material-symbols-rounded">flag</i>
            <span *ngIf="editSectionName !== section.id">{{ section.name }}</span>
            <mat-icon
              (click)="editSectionName = section.id; $event.stopPropagation()"
              *ngIf="
                editSectionName !== section.id && scopeApprovalFlowService.isScopeEditable(tableConfig?.scopeVersion)
              "
              class="material-symbols-rounded fill orange text-sm ml-1.5"
              >mode_edit</mat-icon
            >
            <scope-ui-input
              *ngIf="editSectionName === section.id"
              class="edit-name"
              (click)="$event.stopPropagation()"
              [initialValue]="section.name"
              [autofocus]="true"
              (onInputBlurChange)="updateSectionName($event, section)" />
          </div>
        </div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.DELIVERY_STATUS?.isVisible()"></div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.CREATED_BY?.selected"></div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.OWNER?.selected">
          &nbsp;
        </div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.DATE_CREATED?.selected"></div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.QUANTITY?.selected"></div>
        <div
          class="column one--column"
          [hidden]="!isPreferenceActive(tableConfig?.userColumns.START_DATE)">
          <div class="inline-flex items-center">
            {{ section.startDate || tableConfig?.scopeVersion.startDate | dateFormat: 'shortDate' }}
            <mat-icon
              #startDateMenuTrigger
              [matMenuTriggerFor]="startDateEditor"
              class="material-symbols-rounded fill orange text-sm"
              (click)="$event.stopPropagation()"
              >mode_edit</mat-icon
            >
            <mat-menu
              #startDateEditor
              id="startDateEditor">
              <scope-ui-datepicker
                [initialValue]="section.startDate || tableConfig?.scopeVersion.startDate"
                [singleDatePicker]="true"
                [inlineDatePicker]="true"
                [minDate]="tableConfig?.scopeVersion.startDate"
                [maxDate]="tableConfig?.scopeVersion.endDate"
                (onSelect)="updateStartDate($event)">
              </scope-ui-datepicker>
            </mat-menu>
          </div>
        </div>
        <div
          class="column one--column"
          [hidden]="!isPreferenceActive(tableConfig?.userColumns.END_DATE)">
          <div class="inline-flex items-center">
            {{ section.endDate || tableConfig?.scopeVersion.endDate | dateFormat: 'shortDate' }}
            <mat-icon
              #endDateMenuTrigger
              [matMenuTriggerFor]="endDateEditor"
              class="material-symbols-rounded fill orange text-sm"
              (click)="$event.stopPropagation()"
              >mode_edit</mat-icon
            >
            <mat-menu
              #endDateEditor
              id="endDateEditor">
              <scope-ui-datepicker
                [initialValue]="section.endDate || tableConfig?.scopeVersion.endDate"
                [singleDatePicker]="true"
                [inlineDatePicker]="true"
                [minDate]="section.startDate || tableConfig?.scopeVersion.startDate"
                [maxDate]="tableConfig?.scopeVersion.endDate"
                (onSelect)="updateEndDate($event)">
              </scope-ui-datepicker>
            </mat-menu>
          </div>
        </div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.MARK_UP?.selected"
          [has-privilege]="'SCOPE_MARKUP__VIEW'"
          [has-privilege-entity]="tableConfig?.scopeVersion">
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                fieldName: 'markup',
                valueFn: formatPercentage,
                defaultValue: section.markup,
              }
            " />
        </div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.PROFIT?.selected"
          [has-privilege]="'SCOPE_MARKUP__VIEW'"
          [has-privilege-entity]="tableConfig?.scopeVersion">
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                fieldName: 'totalProfit',
                valueFn: formatPrice,
                defaultValue: section.getTotalProfit(tableConfig?.currency)?.amount,
              }
            " />
        </div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.SCOPEMARK_HOURS?.selected">
          {{ section.scopemarkHours(tableConfig?.scopeVersion) | formatHours }}
        </div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.SCOPEMARK_PRICE?.selected">
          {{
            section.getScopemarkPrice(tableConfig?.scopeVersion).amount
              | convertCurrency: exchangeRateService.selectedCurrency
          }}
        </div>
        <div
          class="column {{ tableConfig?.isTimeline ? 'three--columns' : 'one--column' }}"
          [hidden]="!tableConfig?.isTimeline && !tableConfig?.userColumns.AGENCY_HOURS?.selected">
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                fieldName: 'rateCardTotalHours',
                valueFn: formatHours,
                defaultValue: section.rateCardTotalHours,
              }
            " />
        </div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.UNIT_PRICE?.selected"></div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.BUDGET?.selected"></div>
        <div
          class="column one--column"
          [hidden]="!tableConfig?.userColumns.BALANCE?.selected"></div>
        <div
          class="column {{ tableConfig?.isTimeline ? 'three--columns' : 'one--column' }}"
          [hidden]="!tableConfig?.isTimeline && !tableConfig?.userColumns.AGENCY_PRICE?.selected">
          <ng-container
            *ngTemplateOutlet="
              fieldDifference;
              context: {
                fieldName: 'totalSellingPrice',
                valueFn: formatPrice,
                defaultValue: section.getTotalSellingPrice(tableConfig?.scopeVersion)?.amount,
              }
            " />
        </div>
        <div class="column one--column">
          <button
            *ngIf="scopeApprovalFlowService.isScopeEditable(tableConfig?.scopeVersion)"
            class="toggle-button float-right {{ tableConfig?.isTimeline ? 'mr-1' : 'mr-2' }}"
            (click)="$event.stopPropagation()"
            #menuTrigger="matMenuTrigger"
            mat-mini-fab
            [matMenuTriggerFor]="sectionMenu">
            <mat-icon class="material-symbols-rounded">more_horiz</mat-icon>
          </button>
        </div>
        <mat-menu
          #sectionMenu="matMenu"
          backdropClass="customize">
          <button
            mat-menu-item
            *ngIf="
              scopeApprovalFlowService.isScopeEditable(tableConfig?.scopeVersion) &&
              currentUser.company.hasApplicationSetting('FEE_ITEM__ENABLE') &&
              currentUser.company.hasApplicationSetting('SCOPE__ENABLE_SECTION_FEES') &&
              currentUser.hasPrivilege('SCOPE__CREATE_FEES')
            "
            (click)="onAddSectionFee.emit(section)">
            <mat-icon class="material-symbols-rounded orange">attach_money</mat-icon>
            <span>Add fee</span>
          </button>
          <button
            mat-menu-item
            (click)="onDeleteSection.emit(section)">
            <mat-icon class="material-symbols-rounded orange">delete</mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>
      <div
        *ngIf="!tableConfig?.isTimeline"
        class="flex flex-col w-full description-container"
        (click)="$event.stopPropagation()">
        <description-editor
          class="level-1"
          [(visible)]="scopeTabService.sectionDescriptionStates[section.id]"
          [model]="section"
          [editable]="scopeApprovalFlowService.isScopeEditable(tableConfig?.scopeVersion)"
          [(disableDragging)]="scopeTabService.disableDragging"
          (onSaveDescription)="updateSectionDescription($event, section)"
          (onSaveNote)="updateSectionNote($event, section)">
        </description-editor>
      </div>
    </div>
  </div>

  <scope-deliverables
    *ngIf="scopeTabService.sectionSelectedStates[section.id] || section.id == scopeTabService.dragTargetId"
    class="tbody table-content mb-2 d-block {{ tableConfig.isTimeline ? 'timeline-view' : '' }}"
    [config]="tableConfig"
    [section]="section"
    [deliverables]="section.deliverables"
    [deliverableMenuOptions]="deliverableMenuOptions"
    [componentMenuOptions]="componentMenuOptions"
    [feeMenuOptions]="feeMenuOptions"
    [level]="1"
    [cdnConfig]="cdnConfig"
    (onExpandDeliverable)="onFetchDeliverable.emit($event.deliverableId)"
    (onUpdateDeliverable)="onUpdateDeliverable.emit($event)"
    (onUpdateFeeItem)="onUpdateFeeItem.emit($event)"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onAcceptDeliverable)="onAcceptDeliverable.emit($event)"
    (onRejectDeliverable)="onRejectDeliverable.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)"
    (onUpdateDeliverableTpc)="onUpdateDeliverableTpc.emit($event)"
    (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
    (onUpdateDeliverableSectionTpc)="onUpdateDeliverableSectionTpc.emit($event)"
    (onReorderDeliverableTpcs)="onReorderDeliverableTpcs.emit($event)"
    (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
    (onReorderDeliverableSectionTpcs)="onReorderDeliverableSectionTpcs.emit($event)"
    (onOverrideComponentQuantity)="onOverrideComponentQuantity.emit($event)"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onMoveComponent)="onMoveComponent.emit($event)"
    (onMoveComponentOutsideDeliverable)="onMoveComponentOutsideDeliverable.emit($event)"
    (onScrolledDown)="fetchDeliverables()">
    <div
      class="text-for-empty"
      *ngIf="
        (scopeTabService.sectionSelectedStates[section.id] || section.id == scopeTabService.dragTargetId) &&
        section.deliverables.length === 0
      ">
      <p class="text">Drag &amp; Drop {{ 'deliverable.p' | lang }}</p>
      <p class="undertext">between sections or from the unsectioned {{ 'deliverable.p' | lang }} below</p>
    </div>
  </scope-deliverables>

  <scope-fees
    *ngIf="section.feeItems?.length"
    [hidden]="
      !(scopeTabService.sectionSelectedStates[section.id] || section.id == scopeElementsService.dragTargetId) ||
      tableConfig?.isTimeline
    "
    [has-setting]="ApplicationSetting.SCOPE__ENABLE_SECTION_FEES"
    [level]="2"
    [parent]="section"
    [columns]="scopeElementsService.sectionFeeColumns"
    [feeMenuOptions]="feeMenuOptions"
    [tableStates]="scopeElementsService.deliverableFeeStates"
    [config]="tableConfig"
    (onUpdateFeeItem)="updateSectionFee($event)">
  </scope-fees>
</div>

<ng-template
  #fieldDifference
  let-fieldName="fieldName"
  let-valueFn="valueFn"
  let-defaultValue="defaultValue">
  <scope-field-difference
    [isChangeRequest]="tableConfig?.isChangeRequest"
    [fieldName]="fieldName"
    [defaultValue]="defaultValue"
    [changes]="section.changes"
    [getFieldToDisplay]="getFieldToDisplay"
    [showDiff]="showDiff"
    [valueFn]="valueFn"
    [showNetDelta]="showNetChanges(fieldName)"
    [netDeltaValue]="getNetChanges(fieldName, defaultValue)" />
</ng-template>
